import { css } from 'emotion';
import { theme } from '@branchjs/neo-components';

const ContentContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const Image = css`
  margin-bottom: 36px;
`;

const Title = css`
  margin-bottom: 16px;
  color: ${theme.colors.text[900]} !important;
`;

const Description = css`
  margin-bottom: 24px;
  color: ${theme.colors.text[700]} !important;
`;

export const ScreenErrorStyles = {
  ContentContainer,
  Image,
  Title,
  Description,
};
